export const tapNdonateAvailableFilters = [
  'organizationId',
  'campaignId',
  'serialNumber',
  'label',
  'model'
];
